import React, { Component } from 'react';
import { connect } from 'react-redux';
import SummarySectionComponent from './SummarySectionComponent';
import { updateCurrentlyOpenSummaries } from 'state/checkoutPage/travelSummary/actions';

class SummarySection extends Component {
  constructor(props) {
    super(props);

    this.bySummaryTypeAndId = getFindBySummaryTypeAndIdCallback(props.summaryKey.id, props.summaryKey.summaryType);
    const collapsed = props.currentlyOpenSummaries.find(this.bySummaryTypeAndId) === undefined;

    this.state = {
      collapsed,
    };

    this.handleOnClickCollapse = this.handleOnClickCollapse.bind(this);
  }

  componentDidUpdate() {
    const { currentlyOpenSummaries } = this.props;
    const { collapsed: currentCollapsed } = this.state;
    const collapsed = currentlyOpenSummaries.find(this.bySummaryTypeAndId) === undefined;

    if (currentCollapsed !== collapsed) {
      this.setState({
        collapsed,
      });
    }
  }

  handleOnClickCollapse() {
    const { summaryKey, updateCurrentlyOpenSummaries } = this.props;

    this.setState(
      ({ collapsed }) => ({ collapsed: !collapsed }),
      () => {
        updateCurrentlyOpenSummaries(summaryKey, this.state.collapsed);
      }
    );
  }

  render() {
    const { collapsed } = this.state;

    return (
      <SummarySectionComponent
        {...this.props}
        collapsed={collapsed}
        onClickCollapse={this.handleOnClickCollapse}
        airlineWhitelabel={this.props.airlineWhitelabel}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    currentlyOpenSummaries: state.checkoutPageTravelSummary.currentlyOpenSummaries,
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCurrentlyOpenSummaries(summaryKey, collapsed) {
      dispatch(updateCurrentlyOpenSummaries(summaryKey, collapsed));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SummarySection);

// Utilities

function getFindBySummaryTypeAndIdCallback(id, type) {
  return function bySummaryTypeAndId(summaryKey) {
    return summaryKey.id === id && summaryKey.summaryType === type;
  };
}
